'use es6';

import { once } from 'underscore';
import { DragDropContext } from 'react-dnd';
import ReactDnDHTML5Backend from 'react-dnd-html5-backend';
/*
  Use this instead of ReactDnD.DragDropContext
  It binds the appropriate backend, and allows us to have
  multiple dnd contexts on the same page which is necessary
  to use drag and drop inside of modals.
  Example usage:
    sharedDragDropContext()(MyComponent)
*/

export default once(() => {
  return DragDropContext(ReactDnDHTML5Backend);
});